import { _ as _createForOfIteratorHelperLoose } from './_rollupPluginBabelHelpers-f5c76728.js';

/**
 * Transforms an array with multiple levels into a flattened one.
 *
 * @example
 * import { flatten } from "reakit-utils";
 *
 * flatten([0, 1, [2, [3, 4], 5], 6]);
 * // => [0, 1, 2, 3, 4, 5, 6]
 */
function flatten(array) {
  var flattened = [];

  for (var _iterator = _createForOfIteratorHelperLoose(array), _step; !(_step = _iterator()).done;) {
    var possibleArray = _step.value;

    if (Array.isArray(possibleArray)) {
      flattened.push.apply(flattened, flatten(possibleArray));
    } else {
      flattened.push(possibleArray);
    }
  }

  return flattened;
}

export { flatten };
